<ng-container *ngIf="licenceCountryBandGroupData">
  <!-- DISPLAY UPGRADE MESSAGE IF SPECTRUM LIGHT -->
  <div class="SpectrumLight-alert" *ngIf="licenceCountryBandGroupData.light">
    <div class="Alert Alert--basic">
      <h3>You need to <b>upgrade your subscription</b> to access all the data in this application.</h3>
    </div>
    <a routerLink='/upgrade/' class="Button Button--blue" (click)="analyticsService.pushUpgradeButtonClickEvent()"><span>Upgrade</span></a>
  </div>
  <div class="TableTitle TableTitle--inlineBlock TableTitle--withSwitch">
    <h2 class="Country">Country</h2>&nbsp;&nbsp;/&nbsp;&nbsp;<h2 class="Bands">Group of bands</h2>
    <h1><a (click)="analyticsService.pushTitleClickEvent()" routerLink='/'>Licences</a> in <a (click)="analyticsService.pushTitleClickEvent()" [routerLink]="'/licences/country/'+licenceCountryBandGroupData.countryCode">{{ ('CountryNames.' + licenceCountryBandGroupData.countryCode) | translate }}</a>&nbsp;<a (click)="analyticsService.pushTitleClickEvent()" [routerLink]="'/licences/bandGroup/'+licenceCountryBandGroupData.bandGroup">{{ ('GroupOfBandsTitles.' + licenceCountryBandGroupData.bandGroup) | translate }}</a></h1>
    <div class="Switch" (click)="toggleActiveMode()" [ngClass]="graphicMode ? 'Active' : ''" *ngIf="isGraphicDataAvailable()">
        <label for="on">
            <span data-title="Graphic"></span>
        </label>
    </div>
  </div>
  <div *ngIf="isTableMode()" class="TableMode" [class.Active]="isTableMode()">
    <table class="table ResponsiveTable ResponsiveTable--withHeaderMobile ResponsiveTable--CountryBand" *ngIf="licenceCountryBandGroupData.licences.length > 0">
      <thead>
        <tr>
          <th scope="col">Licensee</th>
          <th scope="col">Scope</th>
          <th scope="col">MHz</th>
          <th scope="col">Award</th>
          <th scope="col">Duration</th>
          <th scope="col">Licence fee</th>
        </tr>
      </thead>
      <tbody *ngFor="let row of licenceCountryBandGroupData.licences">
        <tr>
          <td data-th="Licensee" [class.EmptyCell]="hideLicensee(row)">
            <div *ngIf="row.licensee" class="NoWrap">{{ row.licensee }}</div>
            <!-- LIGHT COMMENT LOOKS LIKE CONTENT -->
            <div *ngIf="row.licenseeComment" class="RichText" [innerHtml]="isSpectrumLightContent(row.licenseeComment | forceTarget)" [class.DisplayNone]="row.licenseeComment.length===1"></div>
          </td>
          <td data-th="Scope" [class.EmptyCell]="hideScope(row)">
            <!-- LIGHT CONTENT -->
            <!-- <div *ngIf="row.geoScope" [innerHtml]="isSpectrumLightContent(row.geoScope)"></div> -->
            <div *ngIf="row.geoScope" [innerHtml]="row.geoScope"></div>
            <!-- LIGHT COMMENT -->
            <!-- <div *ngIf="row.geoScopeComment && row.geoScopeComment != 'BLUR_COMMENT'" class="RichText" [innerHtml]="row.geoScopeComment | forceTarget" [class.DisplayNone]="row.geoScopeComment.length===1"></div> -->
            <div *ngIf="row.geoScopeComment" class="RichText" [innerHtml]="row.geoScopeComment | forceTarget" [class.DisplayNone]="row.geoScopeComment.length===1"></div>
          </td>
          <td data-th="MHz" class="NoWrap" [class.EmptyCell]="hideMHz(row)">
            <!-- LIGHT CONTENT -->
            <!-- <div *ngIf="row.bandwidth && row.bandwidth != 'BLUR_CONTENT'">{{ row.bandwidth }} in <a [routerLink]="'/licences/band/'+row.bandCode">{{ ('Band.' + row.bandCode) | translate }}</a></div>
            <div *ngIf="row.bandwidth && row.bandwidth === 'BLUR_CONTENT'"><p class="SpectrumLight">Upgrade...</p></div> -->
            <div *ngIf="row.bandwidth">{{ row.bandwidth }} in <a [routerLink]="'/licences/band/'+row.bandCode">{{ ('Band.' + row.bandCode) | translate }}</a></div>
            <!-- LIGHT CONTENT -->
            <div *ngIf="row.mhzFromTo" [innerHtml]="isSpectrumLightContent(row.mhzFromTo)"></div>
            <!-- LIGHT COMMENT LOOKS LIKE CONTENT -->
            <div *ngIf="row.techNeutralLicenceComment" class="RichText" [innerHtml]="isSpectrumLightContent(row.techNeutralLicenceComment | forceTarget)" [class.DisplayNone]="row.techNeutralLicenceComment.length===1"></div>
          </td>
          <td data-th="Award" [class.EmptyCell]="hideAward(row)">
            <ng-container *ngIf="row.award">
              <a [routerLink]="'/awards/'+row.award.awardKey" *ngIf="row.award.awardKey">{{ row.award.awardKey | delete2FirstChar }}</a>
              <div *ngIf="row.award.status">{{ ('AwardType.' + row.award.type) | translate }}</div>
            </ng-container>
          </td>
          <td data-th="Duration" [class.EmptyCell]="hideDuration(row)">
            <!-- LIGHT CONTENT -->
            <div *ngIf="row.duration" [innerHtml]="isSpectrumLightContent(row.duration)"></div>
            <!-- LIGHT CONTENT -->
            <div *ngIf="row.beginDate">Begin: <span [innerHtml]="isSpectrumLightContent(row.beginDate)"></span></div>
             <!-- LIGHT COMMENT LOOKS LIKE CONTENT -->
            <div class="RichText" *ngIf="row.beginDateComment" [innerHtml]="isSpectrumLightContent(row.beginDateComment | forceTarget)" [class.DisplayNone]="row.beginDateComment.length===1"></div>
            <!-- LIGHT CONTENT -->
            <!-- <div *ngIf="row.endDate">Expiry: <span [innerHtml]="isSpectrumLightContent(row.endDate)"></span></div> -->
            <div *ngIf="row.endDate">Expiry: <span [innerHtml]="row.endDate"></span></div>
             <!-- LIGHT COMMENT -->
            <!-- <div class="RichText" *ngIf="row.endDateComment && row.endDateComment  != 'BLUR_COMMENT'" [innerHtml]="row.endDateComment | forceTarget" [class.DisplayNone]="row.endDateComment.length===1"></div> -->
            <div class="RichText" *ngIf="row.endDateComment" [innerHtml]="row.endDateComment | forceTarget" [class.DisplayNone]="row.endDateComment.length===1"></div>
          </td>
          <ng-container *ngIf="currencyService.isEuro()">
            <td data-th="Licence fee" [class.EmptyCell]="hideLicenceFee(row)">
              <!-- LIGHT CONTENT -->
              <div *ngIf="row.fee && row.fee.priceEUR" [innerHtml]="isSpectrumLightContent(row.fee.priceEUR)"></div>
              <!-- LIGHT COMMENT WITH CONTENT LOOK -->
              <div class="RichText" *ngIf="row.feeComment" [innerHtml]="isSpectrumLightContent(row.feeComment) | forceTarget"></div>
            </td>
          </ng-container>
          <ng-container *ngIf="!currencyService.isEuro()">
            <td data-th="Licence fee" [class.EmptyCell]="hideLicenceFee(row)">
              <!-- LIGHT CONTENT -->
              <div *ngIf="row.fee && row.fee.priceUSD" [innerHtml]="isSpectrumLightContent(row.fee.priceUSD)"></div>
              <!-- LIGHT COMMENT WITH CONTENT LOOK -->
              <div class="RichText" *ngIf="row.feeComment" [innerHtml]="isSpectrumLightContent(row.feeComment) | forceTarget" [class.DisplayNone]="row.feeComment.length===1"></div>
            </td>
          </ng-container>
          <!-- LIGHT COMMENT -->
          <td data-th="Comment" class="Comment Comment--cell" *ngIf="row.comment && row.comment  != 'BLUR_COMMENT'" [class.EmptyCell]="row.comment.length===0" [class.DisplayNone]="row.comment.length===1">
            <div class="RichText" [innerHtml]="row.comment | forceTarget"></div>
          </td>
        </tr>
        <!-- LIGHT COMMENT -->
        <tr class="Comment Comment--row" *ngIf="row.comment" [class.DisplayNone]="row.comment.length===1">
          <td colspan="6">
            <table class="BasicResponsiveTable">
              <tbody>
                <tr>
                  <td data-th="List of operators">
                    <span class="RichText" [innerHtml]="isSpectrumLightContent(row.comment | forceTarget)"></span>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="NoResult" *ngIf="licenceCountryBandGroupData.licences.length===0 && !licenceCountryBandGroupData.light">
      <p>No licence registered in the database</p>
    </div>
    <div class="NoResult" *ngIf="licenceCountryBandGroupData.licences.length===0 && licenceCountryBandGroupData.light">
      <p>No licence registered in the database or Upgrade your subscription</p>
    </div>
  </div>
  <div *ngIf="isGraphicMode()" class="GraphicMode" [class.Active]="isGraphicMode()">
    <ul class="FrequencyDistribution-list">
      <li class="FrequencyDistribution-listItem" *ngFor="let band of licenceCountryBandGroupData.frequencyDistributions.frequencyDistributionList">
        <h5>{{ ('Band.' + band.bandCode) | translate }}</h5>
        <div class="FrequencyDistribution" *ngIf="band.ranges.length > 0">
          <div class="FrequencyDistribution-container">
            <div *ngFor="let frequency of band.ranges" class="Frequency-container" [ngClass]="frequency.duplexModeWay" [ngStyle]="{'-ms-flex-preferred-size': frequency.percent+'%', 'flex-basis': frequency.percent+'%'}">
              <p class="Start">{{ frequency.start }}</p>
              <p class="End">{{ frequency.end }}</p>
              <div class="Frequency">
                <div class="Block-container">
                  <div *ngFor="let block of frequency.licences"  class="Block" [ngClass]="block.classification" [ngStyle]="{'-ms-flex-preferred-size': block.percent+'%', 'flex-basis': block.percent+'%'}">
                    <h4>{{block.size}}</h4>
                  </div>
                </div>
              </div>
              <h3 class="Title">{{ ('Frequency.' + frequency.duplexModeWay) | translate }}</h3>
            </div>
          </div>
          <ul class="Legend">
            <li *ngFor="let operator of band.legend.classification | keyvalue">
              <span [ngClass]="operator.key"></span>
              <p>{{operator.value}}</p>
              <!-- <sup *ngIf="operator.value==='Regional licences'">*</sup> -->
              <sup *ngIf="showAsterisk(operator, band.legend.allGroupedNames)">*</sup>
            </li>
            <legend *ngIf="band.legend.allGroupedNames">* {{ band.legend.allGroupedNames }}</legend>
          </ul>
        </div>
        <div class="FrequencyDistribution FrequencyDistribution--notAvailable" *ngIf="band.ranges.length===0 && !band.light">
          <p class="Start">{{ band.noGraphFallback.start }}</p>
          <p class="End">{{ band.noGraphFallback.end }}</p>
          <div class="FrequencyDistribution-container">
            <p *ngIf="band.noGraphFallback.percent === 0">
              <b *ngIf="band.noGraphFallback.nationalRegionalCount.regional">Regional licences -</b>
              <b *ngIf="band.noGraphFallback.nationalRegionalCount.local">Local licences -</b>
              &nbsp;The exact location of the licences within the band is not available yet.
            </p>
            <p *ngIf="band.noGraphFallback.percent > 0"><b>{{ band.noGraphFallback.percent }}% <span *ngIf="band.noGraphFallback.mhzTotalSize!=0">({{ band.noGraphFallback.mhzTotalSize }} MHz) </span>awarded</b> - The exact location of the licences within the band is not available yet.</p>
            <span class="Progress" [style.width]="band.noGraphFallback.percent+'%'"></span>
          </div>
          <ul class="Legend Legend--noGraphFallback">
            <li *ngFor="let operator of band.noGraphFallback.operators">
              <span></span>
              <p>{{operator}}</p>
              <!-- <sup *ngIf="operator.value==='Regional licences'">*</sup> -->
              <sup *ngIf="showAsterisk(operator, band.legend.allGroupedNames)">*</sup>
            </li>
            <legend *ngIf="band.legend.allGroupedNames">* {{ band.legend.allGroupedNames }}</legend>
          </ul>
        </div>
        <div class="NoResult NoResult--spectrumLight" *ngIf="band.ranges.length===0 && band.light">
          <p>You need to <b>upgrade your subscription</b> to see this graphic</p>
        </div>
      </li>
    </ul>
  </div>
</ng-container>
